$(document).ready( function () {
  var $form = $('[data-mailchimp-newsletter]');

  if ($form.length > 0) {
    $form.submit(function(event) {
      if (event) {
        event.preventDefault();
      }
      mcRegister($(this));
    });
  }
});

function mcRegister($form) {
  console.log($form);
  $.ajax({
    type: $form.attr('method'),
    url: $form.attr('action'),
    data: $form.serialize(),
    cache: false,
    dataType: 'json',
    contentType: "application/json; charset=utf-8",
    error: function(err) { alert("Could not connect to the registration server. Please try again later."); },
    success: function(data) {
      if (data.result != "success") {
        console.log(data);
        $form.find('[data-mailchimp-newsletter-message]').html(translateMailChimpMsg(data.msg));
      } else {
        console.log(data);
        $form.find('[data-mailchimp-newsletter-message]').html(translateMailChimpMsg(data.msg));
        setTimeout(function() {
          $form.parent('.modal-body').find('[data-dismiss="modal"]').click();
        }, 3000);
      }
    }
  });
}

function translateMailChimpMsg(message) {
  var parts = message.split(' - ');
  if (parts[1] !== undefined) {
    if (parts[1].indexOf('Please enter a value') >= 0) {
      return '<span data-error>Please enter your email</span>';
    } else if (parts[1].indexOf('We have sent you a confirmation email') >= 0) {
      return '<span data-error>We have sent you a confirmation email</span>';
    } else if (parts[1].indexOf('An email address must contain a single @') >= 0) {
      return '<span data-error>An email address must contain a single @</span>';
    } else if (parts[1].indexOf('The domain portion of the email address is invalid (the portion after the @:') >= 0) {
      return '<span data-error>The domain portion of the email address is invalid (the portion after the @: )</span>';
    } else if (parts[1].indexOf('The username portion of the email address is invalid (the portion before the @:') >= 0) {
      return '<span data-error>The username portion of the email address is invalid (the portion before the @: )</span>';
    } else if (parts[1].indexOf('This email address looks fake or invalid. Please enter a real email address') >= 0) {
      return '<span data-error>This email address looks fake or invalid. Please enter a real email address</span>';
    } else {
      return message;
    }
  } else {
    if (message.indexOf('already subscribed') >= 0) {
      return '<span data-error>This email address is already signed up</span>';
    } else if (message.indexOf('Thank you for subscribing!') >= 0) {
      return '<span data-success>' + message + '</span>';
    } else {
      return '<span data-error>' + message + '</span>';
    }
  }
  
}